import React from "react";

export default function StarredWordsPage({
  starredWords,
  goHome,
  openWordDetail,
  handleUnstarWord,
  speakFrench,
  COLORS
}) {
  // 确保COLORS有默认值
  const colors = COLORS || {
    background: "#f5f5f5",
    card: "#ffffff",
    primary: "#2196f3",
    textPrimary: "#212121",
    textSecondary: "#757575",
    border: "#e0e0e0"
  };

  return (
    <div style={{
      padding: "20px",
      maxWidth: "400px",
      margin: "0 auto",
      minHeight: "100vh",
      boxSizing: "border-box",
      backgroundColor: colors.background,
    }}>
      {/* 顶部导航 */}
      <div style={{
        display: "flex",
        alignItems: "center",
        marginBottom: "20px",
        paddingTop: "10px",
      }}>
        <button
          onClick={goHome}
          style={{
            background: "none",
            border: "none",
            fontSize: "20px",
            cursor: "pointer",
            marginRight: "10px",
            color: colors.textPrimary,
          }}
        >
          ←
        </button>
        <h1 style={{
          margin: 0,
          fontSize: "20px",
          color: colors.primary,
          flex: 1,
          textAlign: "center",
        }}>
          我的星标单词
        </h1>
        <div style={{ width: "24px" }}></div> {/* 占位符 */}
      </div>

      {/* 空状态提示 */}
      {starredWords.length === 0 ? (
        <div style={{
          textAlign: "center",
          marginTop: "60px",
          padding: "20px",
        }}>
          <div style={{ fontSize: "48px", marginBottom: "20px" }}>⭐</div>
          <h3 style={{ color: colors.textPrimary, marginBottom: "10px" }}>
            暂无星标单词
          </h3>
          <p style={{ color: colors.textSecondary }}>
            点击单词详情页的⭐按钮收藏单词
          </p>
          <button
            onClick={goHome}
            style={{
              marginTop: "20px",
              padding: "8px 20px",
              backgroundColor: colors.primary,
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            返回首页
          </button>
        </div>
      ) : (
        /* 星标单词列表 */
        <div style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          maxHeight: "calc(100vh - 100px)",
          overflowY: "auto",
        }}>
          {starredWords.map((word) => (
            <div
              key={word.id}
              style={{
                backgroundColor: colors.card,
                borderRadius: "8px",
                padding: "15px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ flex: 1 }}>
                <div style={{
                  fontSize: "18px",
                  fontWeight: "500",
                  color: colors.textPrimary,
                  marginBottom: "5px",
                }}>
                  {word.word}
                </div>
                <div style={{
                  fontSize: "14px",
                  color: colors.textSecondary,
                }}>
                  {word.translation}
                </div>
              </div>
              <div style={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
              }}>
                {/* 发音按钮 */}
                <button
                  onClick={() => speakFrench(word.word)}
                  style={{
                    background: "none",
                    border: "none",
                    fontSize: "18px",
                    cursor: "pointer",
                    color: colors.primary,
                  }}
                >
                  🔊
                </button>
                {/* 详情按钮 */}
                <button
                  onClick={() => openWordDetail(word.id)}
                  style={{
                    padding: "6px 10px",
                    backgroundColor: "#e3f2fd",
                    color: colors.primary,
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "12px",
                  }}
                >
                  详情
                </button>
                {/* 取消星标 */}
                <button
                  onClick={() => handleUnstarWord(word.id)}
                  style={{
                    padding: "6px 10px",
                    backgroundColor: "#ffebee",
                    color: "#f44336",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "12px",
                  }}
                >
                  取消
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}